export const LOCALES = {
  ENGLISH: "en",
  ARABIC: "ar",
  ISRAEL: "he",
};

export const LOCALES_COUNTRIES = {
  en: "US",
  ar: "PS",
  he: "IL",
};

export const AVALIABLE_LANGUAGES = {
  ar: "arabic",
  en: "english",
  he: "israel",
}